

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { PasswordForm, employeeApis, InvalidParam } from '../../api';
import { AESFunction } from '@/common/cryptoAES';
import { CookieFunction } from '@/common/cookie';
import { Dialog } from 'vant';

@Component
export default class MySettings extends Vue {
  readonly labelWidth = '6rem';

  @Ref('password-form') passwrodForm!: ElForm;

  pwdData: PasswordForm = {} as PasswordForm;
  errors = {};

  async submitPassword() {
    if (this.pwdData.new_password !== this.pwdData.repeat_new_password) {
      this.errors = {
        repeat_new_password: '两次输入的新密码不一致，请重新输入。'
      };
    } else {
      this.savePassword();
    }
  }

  async savePassword() {
    if (!this.pwdData.cur_password) {
      this.pwdData.cur_password = '';
    }
    if (!this.pwdData.new_password) {
      this.pwdData.new_password = '';
    }
    if (!this.pwdData.repeat_new_password) {
      this.pwdData.repeat_new_password = '';
    }
    this.errors = {};
    try {
      const encryptStr = new this.$jsEncrypt();
      const pubKeyResult = await employeeApis.getPublicKey();
      const pubKey = pubKeyResult.key;
      const timestamp = pubKeyResult.timestamp;
      encryptStr.setPublicKey(pubKey); // 设置 加密公钥
      const cur_data = encryptStr.encrypt(this.pwdData.cur_password.toString() + '&' + timestamp);
      const new_data = encryptStr.encrypt(this.pwdData.new_password.toString() + '&' + timestamp);
      const new_repeat_data = encryptStr.encrypt(this.pwdData.repeat_new_password.toString() + '&' + timestamp);
      const pwdData = {
        cur_password: cur_data,
        new_password: new_data,
        repeat_new_password: new_repeat_data
      };
      await employeeApis.updatePassword(pwdData);
      if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
        CookieFunction.setCookie('passwd', AESFunction.encrypt(this.pwdData.new_password));
      }
      // 如果是内部员工提示一下密码的用途;
      if (!this.$currentIsExternal()) {
        try {
          await Dialog.alert({
            message: this.$passwordTips
          });
        } catch {}
      }
      this.pwdData = {} as PasswordForm;
      this.$router.push('/');
    } catch (e) {
      console.debug(e);
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        Dialog.alert({
          message: e.message
        });
      }
    }
  }
}
